import React from 'react';

import PropTypes from 'prop-types';

import ReferencePickerBlockGroup from '../blocks/ReferencePickerBlockGroup';
import getPluginKey from '../helpers/getPluginKey';

export const ListVariant = ({
  groupData,
  allowRemoveLinkedEntity,
  setDataToConfirmRemoving,
  updateEntitiesInCache,
  onReferenceClickAnalytics,
  sourceEntityId,
  sourceEntityDomain,
  sourceEntityType,
}) => (
  <div>
    {groupData.map(({ plugin, entityCache, relationships }) => {
      return (
        <ReferencePickerBlockGroup
          key={getPluginKey(plugin)}
          plugin={plugin}
          relationships={relationships}
          entitiesCache={entityCache}
          allowRemoveLinkedEntity={allowRemoveLinkedEntity}
          setDataToConfirmRemoving={setDataToConfirmRemoving}
          updateEntitiesInCache={updateEntitiesInCache}
          onReferenceClickAnalytics={onReferenceClickAnalytics}
          sourceEntityId={sourceEntityId}
          sourceEntityDomain={sourceEntityDomain}
          sourceEntityType={sourceEntityType}
        />
      );
    })}
  </div>
);

ListVariant.propTypes = {
  /**
   *  Data by groups to be displayed
   */
  groupData: PropTypes.arrayOf(
    PropTypes.shape({
      plugin: PropTypes.shape({
        PluralText: PropTypes.func,
      }),
      entityCache: PropTypes.object,
      relationships: PropTypes.array.isRequired,
    }),
  ).isRequired,
  /**
   * Allow remove linked entities.
   */
  allowRemoveLinkedEntity: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  /**
   * Function to set data to confirm removing
   */
  setDataToConfirmRemoving: PropTypes.func.isRequired,
  /**
   * Function to update entities in cache
   */
  updateEntitiesInCache: PropTypes.func,
  /**
   * Function to handle reference click analytics
   */
  onReferenceClickAnalytics: PropTypes.func,
  /**
   * Source entity id
   */
  sourceEntityId: PropTypes.string.isRequired,
  /**
   * Source entity domain
   */
  sourceEntityDomain: PropTypes.string.isRequired,
  /**
   * Source entity type
   */
  sourceEntityType: PropTypes.string.isRequired,
};
